export const theme = {
  colors: {
    // ── Floodlight palette (CSS custom properties) ───────────
    bg: "var(--c-bg)",
    bgCard: "var(--c-bg-card)",
    bgCardHover: "var(--c-bg-card-hover)",
    bgInput: "var(--c-bg-input)",
    border: "var(--c-border)",
    borderFocus: "var(--c-border-focus)",
    text: "var(--c-text)",
    textMuted: "var(--c-text-muted)",
    textDim: "var(--c-text-dim)",
    primary: "var(--c-primary)", // electric lime
    primaryFg: "var(--c-primary-fg)",
    primaryHover: "var(--c-primary-hover)",
    accent: "var(--c-accent)", // warm signal
    accentFg: "var(--c-accent-fg)",
    danger: "var(--c-danger)",
    dangerHover: "var(--c-danger-hover)",
    success: "var(--c-success)",
    warning: "var(--c-warning)",
    gold: "var(--c-gold)",
    silver: "var(--c-silver)",
    bronze: "var(--c-bronze)",
    neon: "var(--c-neon)",

    // ── Court / surface ──────────────────────────────────────
    court: "var(--c-court)",
    courtLine: "var(--c-court-line)",
    secondary: "var(--c-secondary)",
    secondaryHover: "var(--c-secondary-hover)",
    muted: "var(--c-muted)",

    // ── Team palette ─────────────────────────────────────────
    teamA: "var(--c-team-a)", // crimson
    teamB: "var(--c-team-b)", // azure
    teamC: "var(--c-team-c)", // sun
    teamD: "var(--c-team-d)", // orchid
  },
  radii: {
    sm: "8px",
    md: "12px",
    lg: "14px",
    xl: "16px",
    "2xl": "20px",
    "3xl": "24px",
    full: "9999px",
  },
  shadow: {
    card: "var(--shadow-card)",
    glow: "var(--shadow-glow)",
  },
  gradients: {
    floodlight: "var(--grad-floodlight)",
    primary: "var(--grad-primary)",
    court: "var(--grad-court)",
  },
  fonts: {
    display: '"Bricolage Grotesque", ui-sans-serif, system-ui, sans-serif',
    body: '"Inter", ui-sans-serif, system-ui, sans-serif',
  },
  /** Mobile-first breakpoints — min-width */
  bp: {
    sm: "@media (min-width: 480px)",
    md: "@media (min-width: 768px)",
    lg: "@media (min-width: 1024px)",
  },
  /** Minimum tap target per WCAG / Apple HIG */
  touch: "44px",
} as const;

export type Theme = typeof theme;

/** Team color keys for look-ups */
export type TeamColorKey = "team-a" | "team-b" | "team-c" | "team-d";

export const TEAM_COLORS: Record<TeamColorKey, string> = {
  "team-a": theme.colors.teamA,
  "team-b": theme.colors.teamB,
  "team-c": theme.colors.teamC,
  "team-d": theme.colors.teamD,
};

export const CHART_TEXT = theme.colors.textMuted;
export const CHART_GRID = theme.colors.border;
export const CHART_COLORS = [
  "#6366f1",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
  "#06b6d4",
  "#ec4899",
  "#8b5cf6",
  "#14b8a6",
  "#f97316",
  "#a3e635",
  "#e879f9",
  "#2dd4bf",
];
